export default "https://statics.cloudfastin.top/static/v1.27.38.3-s.dispute.2/store/images/new_codedisplay_1_left.png?99c3a22a3d7a7190554d009217c0b825";